// extracted by mini-css-extract-plugin
export default {"cardStack":"SkeletonCardPage_cardStack__nxsEP"};